
window.$ = window.jQuery = require('jquery');
require('./web_function')
require('./dialogs/confirm_dialog')

import 'slick-carousel';
